// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"; 



const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_F3XP5EPKz",
  client_id: "2ds0n55qp7q33u18bj5034cf3p",
  client_secret:"1gddmkiv95bk0ulhfv49odil9e2vo2k22r6apdn6cpitfecb0elc",
  redirect_uri: window.location.origin,
  response_type: "code",
  post_logout_redirect_uri: window.location.origin,
  scope: "email openid phone",
  loadUserInfo: true,
 extraQueryParams: {
    // This must match the IdP name you set in Cognito
    identity_provider: "EntraID"
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);